export default (
    component_name,
    months,
    options = {
        multiple: false,
        initialValues: undefined,
        selectedMonth: undefined,
    }
) => ({
    months,

    selectedMonth: undefined,
    selectedMonthIndex: -1,
    selectedDays: null,

    toggleSelectAll: false,
    showMonths     : false,
    isSubmitted    : false,
    isDisabled     : false,

    init() {
        const mesesNombres = months.map(({nombre}) => nombre.toLowerCase());

        //? Si no se proporciona el mes seleccionado, se selecciona el mes actual
        if (options.selectedMonth !== undefined && options.selectedMonth !== null && mesesNombres.includes(options.selectedMonth.toLowerCase())){
            const month = months.find(m => m.nombre.toLowerCase() === options.selectedMonth.toLowerCase());

            this.selectedMonth = month;
            this.selectedMonthIndex = months.indexOf(month);

        }else{
            const date = new Date();
            const month = date.toLocaleString('default', { month: 'long' });

            const monthIndex = months.findIndex(m => m.nombre.toLowerCase() === month);

            this.selectedMonth = months[monthIndex];
            this.selectedMonthIndex = monthIndex;
        }

        this.$watch('selectedDays', (value, old) => {
            if (options.multiple && options.multiple === true) {
                const sortedDays = [...this.selectedDays].sort((a, b) => a - b);
                this.$dispatch(`${component_name}-change`, [sortedDays, this.selectedMonth, this.isValid]);
                return;
            }

            this.$dispatch(`${component_name}-change`, [value, this.selectedMonth, this.isValid]);
        });

        if (options.initialValues !== undefined && options.initialValues !== null) {
            this.selectedDays = options.multiple && options.multiple === true ? [...options.initialValues] : options.initialValues;
        } else {
            this.selectedDays = options.multiple && options.multiple === true ? [] : undefined;
        }
    },

    cleanSelectedDays(){
        this.selectedDays = [];
    },

    nextMonth(){
        this.selectedMonthIndex++;
        if(this.selectedMonthIndex > 11){
            this.selectedMonthIndex = 0;
        }

        this.selectedMonth = months[this.selectedMonthIndex];
    },

    prevMonth(){
        this.selectedMonthIndex--;
        if(this.selectedMonthIndex < 0){
            this.selectedMonthIndex = 11;
        }

        this.selectedMonth = months[this.selectedMonthIndex];
    },

    setSelectedMonth(month){
        this.showMonths = false;

        const monthIndex = months.findIndex(m => m.id === month.id);

        this.selectedMonth = months[monthIndex];
        this.selectedMonthIndex = monthIndex;

        // Eliminamos los dias seleccionados que no existen en el mes seleccionado
        this.selectedDays = options.multiple
            ? this.selectedDays.filter(day => day < month.num_dias)
            : this.selectedDays > month.num_dias ? undefined : this.selectedDays;
    },

    get isValid() {
        if (options.required === true) {
            return options.multiple
                ? this.selectedDays.length > 0
                : this.selectedDays !== undefined;
        }
        return true;
    }
})
